import { feedbackStore, PRIMARY_SITES, REVIEWER_ROLES } from '../data/feedback-store.js';

export function renderProfileModal() {
  const state = feedbackStore.getState();
  const { name, email, role, site } = state.profile;
  const isValid = feedbackStore.isProfileValid();

  return `
    <div id="profile-modal" class="lightbox-modal" style="display: none;">
      <div class="lightbox-overlay" id="profile-modal-backdrop"></div>
      <div class="lightbox-content-box" style="max-width: 620px; padding: var(--space-2xl);">
        <button class="lightbox-close-btn" id="btn-close-profile-modal">&times;</button>
        
        <div style="display: flex; align-items: center; gap: var(--space-sm); margin-bottom: var(--space-xs);">
          <span style="font-size: 24px;">👤</span>
          <h3 style="margin: 0; font-size: var(--text-2xl); color: var(--text-primary);">Reviewer Profile</h3>
        </div>
        <p style="font-size: var(--text-sm); color: var(--text-secondary); margin-bottom: var(--space-xl);">
          To help UVC leadership and Church Council contextualize your feedback, please identify yourself and your campus affiliation.
        </p>

        <form id="reviewer-profile-form" onsubmit="return false;" style="display: flex; flex-direction: column; gap: var(--space-lg);">
          <!-- Name (Required) -->
          <div>
            <label for="prof-name" style="display: block; font-size: var(--text-xs); font-weight: 700; color: var(--text-primary); text-transform: uppercase; margin-bottom: 6px;">
              Full Name <span style="color: var(--accent-rose, #FF3D71);">* Required</span>
            </label>
            <input 
              type="text" 
              id="prof-name" 
              name="name" 
              class="form-input" 
              placeholder="e.g. Rev. Jonathan Grace or Jordan Smith" 
              value="${name || ''}" 
              required
            />
          </div>

          <!-- Email (Required) -->
          <div>
            <label for="prof-email" style="display: block; font-size: var(--text-xs); font-weight: 700; color: var(--text-primary); text-transform: uppercase; margin-bottom: 6px;">
              Email Address <span style="color: var(--accent-rose, #FF3D71);">* Required</span>
            </label>
            <input 
              type="email" 
              id="prof-email" 
              name="email" 
              class="form-input" 
              placeholder="name@example.com" 
              value="${email || ''}" 
              required
            />
          </div>

          <!-- Role in UVC (Required) -->
          <div>
            <label for="prof-role" style="display: block; font-size: var(--text-xs); font-weight: 700; color: var(--text-primary); text-transform: uppercase; margin-bottom: 6px;">
              Your Relationship / Role at UVC <span style="color: var(--accent-rose, #FF3D71);">* Required</span>
            </label>
            <select id="prof-role" name="role" class="form-select" required>
              <option value="" disabled ${!role ? 'selected' : ''}>-- Select Your Role --</option>
              ${REVIEWER_ROLES.map(r => `
                <option value="${r}" ${role === r ? 'selected' : ''}>${r}</option>
              `).join('')}
            </select>
          </div>

          <!-- Primary Site Affiliation (Required - 5 Options) -->
          <div>
            <label style="display: block; font-size: var(--text-xs); font-weight: 700; color: var(--text-primary); text-transform: uppercase; margin-bottom: 8px;">
              Primary Site / Campus <span style="color: var(--accent-rose, #FF3D71);">* Required (5 Options)</span>
            </label>
            <div class="site-radio-grid" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(130px, 1fr)); gap: var(--space-sm);">
              ${PRIMARY_SITES.map(s => `
                <label class="site-radio-card ${site === s.id ? 'active' : ''}">
                  <input type="radio" name="site" value="${s.id}" ${site === s.id ? 'checked' : ''} style="display: none;" />
                  <div class="site-radio-badge">${s.id}</div>
                  <div class="site-radio-name">${s.name}</div>
                </label>
              `).join('')}
            </div>
          </div>

          <div id="profile-validation-msg" style="display: none; font-size: var(--text-xs); color: #FF3D71; font-weight: 600;">
            ⚠️ Please complete all required fields (Name, valid Email, Role, and Primary Site).
          </div>

          <div style="display: flex; justify-content: flex-end; gap: var(--space-sm); margin-top: var(--space-sm); border-top: 1px solid var(--border-subtle); padding-top: var(--space-md);">
            <button type="button" class="btn btn-secondary" id="btn-cancel-profile">Cancel</button>
            <button type="button" class="btn btn-primary" id="btn-save-profile" style="background: var(--accent-primary); color: #FFFFFF; padding: 10px 24px;">
              Save &amp; Continue Review
            </button>
          </div>
        </form>
      </div>
    </div>
  `;
}

export function renderProfileHeaderPill() {
  const state = feedbackStore.getState();
  const { name, role, site } = state.profile;
  const isValid = feedbackStore.isProfileValid();

  if (isValid) {
    return `
      <div class="reviewer-pill active" id="btn-open-profile" title="Click to edit your reviewer information">
        <div style="display: flex; align-items: center; gap: 8px; overflow: hidden;">
          <span style="font-size: 16px;">👤</span>
          <div style="text-align: left; line-height: 1.2; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <div style="font-weight: 700; color: var(--text-primary); font-size: 12px;">${name}</div>
            <div style="font-size: 10px; color: var(--accent-primary); font-weight: 600;">${site} • ${role.split('/')[0].trim()}</div>
          </div>
        </div>
        <span style="font-size: 10px; color: var(--text-tertiary); margin-left: 6px;">✏️ Edit</span>
      </div>
    `;
  }

  return `
    <button class="reviewer-pill pulse-attention" id="btn-open-profile">
      <span style="font-size: 14px;">⚠️</span>
      <div style="text-align: left; line-height: 1.2;">
        <div style="font-weight: 700; color: #FFB300; font-size: 11px;">Set Reviewer Profile</div>
        <div style="font-size: 9px; color: var(--text-tertiary);">Name &amp; Site Required for Ballot</div>
      </div>
      <span class="badge" style="background: #FFB300; color: #000; font-size: 9px; padding: 1px 5px; margin-left: auto;">Setup</span>
    </button>
  `;
}
